import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  root: {
    transition: 'opacity 1s ease-in-out',
    width: 'calc(100% + 8px)',
    marginLeft: -4,
  },

  container: {
    transition: 'opacity 0s',
  },
}));
